/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  position: relative;
  width: inherit;
  height: auto;
  .fill-1 {
    fill: #ff5023;
  }
  .fill-2 {
    fill: #040405;
  }
  .none {
    fill: transparent;
  }
`
export default class BasketballIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="90" height="90" viewBox="0 0 90 90" css={Color}>
        <g id="그룹_7154" data-name="그룹 7154" transform="translate(5103 -1718)">
          <rect id="사각형_6691" className="fill-1" data-name="사각형 6691" width="89.989" height="89.989" rx="44.994" transform="translate(-5103 1718)" fill="#ff5023"/>
          <path id="패스_6699" className="fill-2" data-name="패스 6699" d="M362.495,466.261a44.994,44.994,0,1,1,44.994-44.995A45.046,45.046,0,0,1,362.495,466.261Zm0-84.989a39.994,39.994,0,1,0,40,39.995,40.039,40.039,0,0,0-40-39.995Z" transform="translate(-5420.5 1341.728)" fill="#040405"/>
          <path id="패스_6700" className="none" data-name="패스 6700" d="M362.495,466.265a44.88,44.88,0,0,1-33.536-15,44.88,44.88,0,0,1,33.536-15h.011a44.882,44.882,0,0,1,33.537,15,44.882,44.882,0,0,1-33.537,15Z" transform="translate(-5420.5 1341.728)" fill="none"/>
          <path id="패스_6701" className="fill-2" data-name="패스 6701" d="M362.506,463.761a42.294,42.294,0,0,0,25.21-8.283,42.79,42.79,0,0,0,4.889-4.215,42.579,42.579,0,0,0-12.462-8.677,42.141,42.141,0,0,0-17.637-3.821h-.011a42.307,42.307,0,0,0-25.211,8.282,42.9,42.9,0,0,0-4.889,4.216,42.631,42.631,0,0,0,12.462,8.677,42.158,42.158,0,0,0,17.638,3.821h.011m0,2.5h-.011a44.884,44.884,0,0,1-33.538-15,44.884,44.884,0,0,1,33.538-15h.011a44.883,44.883,0,0,1,33.537,15A44.883,44.883,0,0,1,362.506,466.261Z" transform="translate(-5420.5 1341.728)" fill="#040405"/>
          <path id="패스_6702" className="none" data-name="패스 6702" d="M362.494,406.272a44.887,44.887,0,0,1-33.536-15,44.88,44.88,0,0,1,33.536-15h.012a44.88,44.88,0,0,1,33.536,15,44.88,44.88,0,0,1-33.536,15Z" transform="translate(-5420.5 1341.728)" fill="none"/>
          <path id="패스_6703" className="fill-2" data-name="패스 6703" d="M362.506,403.768a42.295,42.295,0,0,0,25.209-8.283,42.787,42.787,0,0,0,4.889-4.215,42.579,42.579,0,0,0-12.462-8.677,42.134,42.134,0,0,0-17.636-3.821h-.012a42.307,42.307,0,0,0-25.211,8.282,42.9,42.9,0,0,0-4.889,4.216,42.63,42.63,0,0,0,12.462,8.677,42.158,42.158,0,0,0,17.638,3.821h.012m0,2.5h-.012a44.884,44.884,0,0,1-33.538-15,44.884,44.884,0,0,1,33.538-15h.012a44.881,44.881,0,0,1,33.536,15A44.881,44.881,0,0,1,362.506,406.268Z" transform="translate(-5420.5 1341.728)" fill="#040405"/>
          <rect id="사각형_5709" className="fill-2" data-name="사각형 5709" width="90" height="2.5" transform="translate(-5103 1761.756)" fill="#040405"/>
          <rect id="사각형_5710" className="fill-2" data-name="사각형 5710" width="2.5" height="89.989" transform="translate(-5059.25 1718.011)" fill="#040405"/>
        </g>
      </svg>

    )
  }
}
